<template>
    <colla class="collapp-comment-box" id="collapp-comment">
        <colla class="collapp-loader" v-show="loading">
            <colla class="collapp-spinner"></colla>
        </colla>

        <form action="" method="post" @submit.prevent="submit">
            <textarea v-model="data.message" v-on:input="showFullForm" class="collapp-input-message" name="message" id="collapp-message" rows="3"
                      placeholder="Your comment..." required></textarea>
            <input v-model="data.name" v-show="fullForm" class="collapp-input-name" type="text" name="name" placeholder="Your Name" required>
            <input v-model="data.thread" v-show="fullForm" class="collapp-input-name" type="hidden" name="thread">
            <input :disabled="loading" v-show="fullForm" class="collapp-input-submit" type="submit" value="Comment">
        </form>
    </colla>
</template>

<script>
    export default {

        props: ['thread'],

        data() {
            return {
                loading: false,
                data: {},
                //thread: this.thread,
                fullForm: false
            }
        },


        watch: {

        },

        methods: {
            showFullForm(event) {
                // hide name and submit button
                this.fullForm = false;

                // activate full form if textarea has min 1 character
                if (event.target.value.length > 0)
                    this.fullForm = true;
            },
            submit() {
                this.loading = true;

                console.log(this.data);

                this.data.time = new Date();
                this.data.thread = '/api/threads/'+this.thread;
                var data = JSON.stringify(this.data);

                console.log(data);

                // Save Comment
                this.$http.post(this.$http.options.api + '/comments', data).then((response) => {
                    // success callback

                    // fire event for comment
                    this.$emit('commented', response.data);

                    // Clear the message
                    this.data.message = "";

                    this.loading = false;
                }, (response) => {
                    // error callback
                    this.loading = false;
                });
            }
        }

    }
</script>

<style>
    .collapp-comment-box {
        background-color: #FFF;
        width: 100%;
        margin: auto;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        display: block;
    }

    .collapp-comment-box form {
        padding: 1rem;
    }

    .collapp-comment-box input, .collapp-comment-box textarea {
        font-size: .8em;
        width: 97.3%;
        padding: .6em;
        border: 1px solid #EEE;
        background-color: #f7f7f7;
        display: block;
        margin-bottom: 1em;
        font-family: 'Raleway', sans-serif;
        transition: all ease 0.3s;
    }

    .collapp-comment-box input:focus, .collapp-comment-box textarea:focus {
        border-color: #47b784;
        outline: none;
        box-shadow: inset 0 0 3px #DDD;
    }

    .collapp-comment-box input[type="submit"] {
        margin-bottom: 0;
        width: 30%;
        background-color: #47b784;
        color: #FFF;
        border-color: #47b784;
        font-weight: bold;
        text-transform: uppercase;
    }

    .collapp-comment-box input[type="submit"]:focus {
        background-color: #36495d;
    }

    .collapp-comment-box input[type="submit"]:disabled {
        opacity: 0.6
    }

    #collapp-comment {
        position: relative;
    }

    #collapp-comment .collapp-spinner {
        margin-top: 5em;
        z-index: 999;
    }

    #collapp-comment .collapp-loader {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.8);
        z-index: 2;
    }
</style>


// WEBPACK FOOTER //
// CommentForm.vue?b09e6e9e